interface CanLeaveDirectRoomParams {
    readonly isRoomDirect: boolean | undefined;
    readonly roomUsersCount: number;
    readonly selectedRoomId: string | null | undefined;
    readonly userWithoutConversation: unknown;
    readonly viewingProfile: boolean;
}

export function canLeaveDirectRoom(params: CanLeaveDirectRoomParams): boolean {
    return Boolean(
        params.isRoomDirect
        && params.roomUsersCount > 0
        && params.selectedRoomId
        && !params.userWithoutConversation
        && params.viewingProfile
    );
}
